import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Link } from 'react-router-dom'
import Home from '../Home'
import HomeOperator from '../Home/index-operator'
import Sales from '../Sales'
import Restaurant from '../Restaurants'
import Helix from '../Helix'
import Stock from '../Stock'
import Location from '../Location'
import Reports from '../Reports'
import Inventory from '../Inventory'

import About from '../About'
import { AuthActions, AuthSelectors } from '../../modules/auth'
import { ConfigSelectors } from '../../modules/config'
import Box from '../../components/Box'
import Chart from '../../components/Chart'
import ListData from '../../components/ListData'
import LoadingModal from '../../components/LoadingModal'
import TopHeader from '../../components/TopHeader'

import "./styles.css";
import {
    Menu,
    Container,
    Dropdown,
    Header,
    Grid,
    Sidebar,
    Icon
} from 'semantic-ui-react'
import Loyalty from '../Loyalty';
import LoyaltySetup from '../LoyaltySetup';
import KE_Data from '../../components/Tabs/ke_data';

const { authOnLogout, authOnInit } = AuthActions;

const { getSelectorAuth } = AuthSelectors;
const { getSelectorConfig } =ConfigSelectors;



class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
    }
    componentWillMount() {
        this.props.authOnInit();
    }

    onLogout() {
        this.props.authOnLogout()
    }

    render() {
        const { filters,history } = this.props
        return (
            <div>
                <div style={styles.modal} className="ui center aligned grid">
                    <LoadingModal />
                </div>
                <div>

                    <TopHeader filters={filters} authOnLogout={this.onLogout} />

                    <Grid padded={true} columns='equal' style={styles.mainGrid}>
                        <Grid.Column>
                            <Switch>
                                <Route exact path="/dashboard/operator" component={HomeOperator} />
                                <Route exact path="/dashboard" component={Home} />
                                <Route exact path="/dashboard/reports" component={Reports} />
                                <Route exact path="/dashboard/setup-loyalty" component={LoyaltySetup} />
                                <Route exact path="/dashboard/loyalty" component={Loyalty} />
                                <Route exact path="/dashboard/sales" component={Sales} />
                                <Route exact path="/dashboard/ke" component={KE_Data} />
                                <Route exact path="/dashboard/stock" component={Stock} />
                                <Route exact path="/dashboard/restaurant" component={Restaurant} />
                                <Route exact path="/dashboard/helix" component={Helix} />
                                <Route exact path="/dashboard/location" component={Location} />
                                {/* <Route exact path="/dashboard/inventory" component={Inventory} /> */}
                            </Switch>

                        </Grid.Column>
                    </Grid>

                </div>



            </div>
        )
    }

}

const styles = {
    mainGrid: {
        backgroundColor: '#f9f9fe'
    },
    dropmain: {
        backgroundColor: 'rgba(0,0,0,0.92)',
        color: '#fff',
        borderRadius: 0,
        marginTop: 2,
    },
    dropinner: {
        color: '#fff',
        borderBottomWidth: 1,
        borderBottomColor: '#af2d2d',
    },
    modal: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 160,
        position: 'absolute',
        top: 60,
        marginTop: 60,
    },
    modalContainer: {
        position: 'absolute',
        top: 70,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        width: 160,
        height: 160,
    },
    iconDrop: {
        fontSize: 15,
        paddingBottom: 25,
        color: '#fff',
    },
    topMenu: {
        color: '#fff',
        borderWidth: 0,
        borderLeftWidth: 0,
        shadowOpacity: 0,
        paddingTop: 13,
        paddingRight: 8,
    },
    topHeader: {
        backgroundImage: 'url(shell_bg.png)',
        backgroundSize: 'cover',
        //backgroundColor: '#652d92',
        color: 'white',
        paddingTop: 5,
        // borderBottomWidth:2,
        // borderBottomColor: '#cb55f8',
    },
    mainBlck: {

        position: 'absolute',
        left: 70,
    },
    title: {
        paddingRight: 10,
        paddingLeft: 10,
        paddingTop: 5,
        paddingBottom: 5,
        fontSize: 22
    },
    leftNav: {
        position: 'relative',
        left: 0,
    },
    sideBar: {
        top: 48,
        backgroundColor: '#2c2435',
    },
    shellLogo: {
        position: 'absolute',
        right: '0',
        marginRight: 40,
        marginTop: 5,
    },
}

const mapStateToProps = state => {
    return getSelectorAuth(state);
}

export default connect(
    mapStateToProps,
    {
        authOnInit,
        authOnLogout,
    })(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js